import React from 'react';
import { Box, Grid } from '@wegroup/design-system';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';
import Avatar from '../../../../../../../sales-conversation/src/components/default/ProdFacAvatar';
import useCurrentGroup from '../../../../../hooks/useCurrentGroup';
import ProgressBar from '../../../../../../../sales-conversation/src/components/default/ProgressBar';
import { useParams } from 'react-router';
import QuestionViewText from '../../../../../../../sales-conversation/src/components/legacy/question-view-header/QuestionViewText';
import ToolbarMobileLoading from './ToolbarMobileLoading';
import LanguageChangeMenu from '../LanguageChangeMenu';

const ProgressBarMobile: React.FC = () => {
  const currentGroup = useCurrentGroup();
  const { position } = useParams<{
    position: string;
  }>();
  const isLoading = useFlowsSelector((state) => state.flows.isLoading);

  const questionnaire = useFlowsSelector((state) => state.flows.questionnaire);
  const currentTag = currentGroup?.tag;
  const nextTag = questionnaire.groups.find(({ tag: _tag }, index) => {
    const previousTag = questionnaire.groups[index - 1]?.tag;
    return previousTag === currentTag && _tag !== currentTag;
  })?.tag;

  if (isLoading) return <ToolbarMobileLoading />;

  return (
    <>
      <Grid
        alignItems="center"
        gridGap="2"
        templateColumns={{
          base: '1fr auto',
          mobileM: '4.4rem 1fr auto',
        }}
        mb="4"
      >
        <Box display={{ base: 'none', mobileM: 'block' }}>
          <Avatar />
        </Box>

        <QuestionViewText
          isSelection={false}
          currentTag={currentTag}
          nextTag={nextTag}
          position={parseInt(position)}
        />
        <LanguageChangeMenu />

        {/* // TEMP: Currently waiting for hubspot to add an event to listen to chat widget minimization */}
        {/* <QuestionViewHeaderSupportButton /> */}
      </Grid>
      <ProgressBar />
    </>
  );
};

export default ProgressBarMobile;
